"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBoxSuppliers = exports.getBoxSuppliersArray = void 0;
var getBoxSuppliersArray = function (box) {
    var _a;
    var suppliers = ((_a = box.suppliers) === null || _a === void 0 ? void 0 : _a.length)
        ? box.suppliers
        : box.products.map(function (p) { return p.supplier; });
    var uniqueSuppliers = new Map(suppliers
        .filter(function (s) { return s; }).map(function (s) { return [s.id, s]; }));
    return Array.from(uniqueSuppliers.values());
};
exports.getBoxSuppliersArray = getBoxSuppliersArray;
var getBoxSuppliers = function (box) {
    return (0, exports.getBoxSuppliersArray)(box)
        .map(function (_a) {
        var substituteName = _a.substituteName, firstname = _a.firstname;
        return substituteName || firstname;
    })
        .filter(Boolean)
        .join(', ');
};
exports.getBoxSuppliers = getBoxSuppliers;
exports.default = { getBoxSuppliersArray: exports.getBoxSuppliersArray, getBoxSuppliers: exports.getBoxSuppliers };
//# sourceMappingURL=BoxSuppliers.js.map